// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse{50%{opacity:.5}}.ucrs-skltn__item{animation:pulse 2s cubic-bezier(.4,0,.6,1) infinite;border-radius:.3rem;--tw-bg-opacity:1;background-color:#e5e5e5;background-color:rgba(229,229,229,var(--tw-bg-opacity))}.ucrs-skltn__item--rounded{border-radius:9999px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
